import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react'
import { Button, Message, useWindowContext, noop } from '@iqueue/ui-kit'
import './translations'
import './UploadLicense.css'
import LicensePresenter from '../../api/licensePrecenter'
import useTranslate, { t } from '../../hooks/useTranslate'

const href = process.env.NODE_ENV === 'production' ? '/api/v1/license/state' : 'http://10.10.11.112:3000/api/v1/license/state'

export default function UploadLicense() {
  const [file, setFile] = useState(null)
  const fileInputRef = useRef(null)
  const { setTitle, togglePaddings } = useWindowContext()
  const locale = useTranslate()
  const translatedTitle = useMemo(() => t('menu.licenses'), [locale])

  const handleFileDrop = useCallback((e) => {
    e.preventDefault()
    if (e.dataTransfer.files.length) {
      setFile(e.dataTransfer.files[0])
    }
  }, [])

  const handleFileChange = useCallback((e) => {
    if (e.target.files.length) {
      setFile(e.target.files[0])
    }
  }, [])

  const handleUpload = useCallback(async () => {
    try {
      const fd = new FormData()
      fd.append('file', file, 'license.abl')

      await LicensePresenter.post('update', fd, {
        authorization: 'Bearer ' + localStorage.getItem('amber-auth-token'),
      }, false)

      Message({
        type: "success",
        timeout: 5000,
        title: "Лицензия успешно загружена!",
      })

      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } catch (error) {
      Message({
        type: "error",
        timeout: 5000,
        subtitle: "Ошибка: " + error.message,
        title: "Не удалось загрузить лицензию",
      })
      setFile(null)
      resetFileInput()
    }
  }, [file])

  const handleOpenFileDialog = useCallback(() => {
    fileInputRef.current.click()
  }, [])

  const resetFileInput = useCallback(() => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null
    }
  }, [])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
  }, [translatedTitle])

  return <div className="upload-container-license">
    <a href={ href } target={ '_blank' }
       style={ { marginBottom: 'var(--iq-grid-spacing)' } }>
      { t('licensesPage.licenses.downloadLicenseInfo') }
    </a>

    <div
      className="drop-area"
      onDragOver={ (e) => e.preventDefault() }
      onDrop={ handleFileDrop }
      onClick={ handleOpenFileDialog }>
      { file ? <p>{ file.name }</p> : <div className="drop-content">
        <b>{ t('licensesPage.licenses.dragOrClick') }</b>
      </div> }
    </div>

    <input
      type="file"
      ref={ fileInputRef }
      className="file-input"
      onChange={ handleFileChange }
      accept=".abl"
    />

    { file && <div className={ 'button-group' }>
      <Button
        danger
        className="cancel-button"
        onClick={ () => setFile(null) }
      >
        { t('licensesPage.crud.cancel') }
      </Button>
      <Button
        primary
        className="upload-button"
        onClick={ handleUpload }
      >
        { t('licensesPage.crud.add') }
      </Button>
    </div> }

  </div>
}
